import React, { MutableRefObject } from 'react';
import styles from './terms_of_service.module.css';
import Messages from './terms_of_service_messages';
import { ActiveButton, DefaultButton } from 'ui/public/button';
import { ButtonClickEvent } from 'ui/base/types';

type TermsOfServiceProps = {
  modalRef: MutableRefObject<HTMLDivElement | null>;
  onAccept(event: ButtonClickEvent): void;
  onReject(): void;
};

export const TermsOfService = ({ modalRef, onAccept, onReject }: TermsOfServiceProps): React.ReactElement => {
  return (
    <div className={styles.modalContent} ref={modalRef}>
      <div className={styles.container}>
        <div className={styles.backButtonContainer}>
          <div className={styles.backButton} onClick={onReject}/>
        </div>
        <div className={styles.titleText}>
          {Messages.beforeYouContinue()}
        </div>
        <div className={styles.subtitleText}>
          {Messages.privacyPolicy()}
        </div>
        <p className={styles.text}>
          {Messages.privacyPolicyIntroductionOfPangolinApp()}
        </p>
        <p className={styles.text}>
          {Messages.toInformVisitorRegardingOurPolicies()}
        </p>
        <p className={styles.text}>
          {Messages.serviceAgreement()}
        </p>
        <p className={styles.text}>
          {Messages.termsInPrivacyPolicy()}
        </p>
        <div className={styles.labelText}>
          {Messages.informationCollectionAndUse()}
        </div>
        <p className={styles.text}>
          {Messages.instructionInformationCollectionAndUse()}
        </p>
        <p className={styles.text}>
          {Messages.theAppDoesUseThirdPartyServices()}
        </p>
        <p>
          <a href='https://play.google.com/about/play-terms.html' className={styles.googlePlayServicesLink}>
            {Messages.googlePlayServices()}
          </a>
        </p>
        <div className={styles.labelText}>
          {Messages.logData()}
        </div>
        <p className={styles.text}>
          {Messages.logDataInfo()}
        </p>
        <div className={styles.labelText}>
          {Messages.cookies()}
        </div>
        <p className={styles.text}>
          {Messages.aboutCookies()}
        </p>
        <p className={styles.text}>
          {Messages.serviceUsesCookies()}
        </p>
        <div className={styles.labelText}>
          {Messages.serviceProviders()}
        </div>
        <p className={styles.text}>
          {Messages.serviceProvidersIntroduction()}
        </p>
        <p className={styles.text}>
          <span className={styles.reasons}>
            {Messages.reasonsForThirdPartyCompanies()}
          </span> {/* eslint-disable-line no-trailing-spaces */}
          {Messages.explinationOfTheReasons()}
        </p>
        <div className={styles.labelText}>
          {Messages.security()}
        </div>
        <p className={styles.text}>
          {Messages.aboutSecurity()}
        </p>
        <div className={styles.labelText}>
          {Messages.linkToOtherSites()}
        </div>
        <p className={styles.text}>
          {Messages.aboutLinksToOtherSites()}
        </p>
        <div className={styles.labelText}>
          {Messages.childernPrivacy()}
        </div>
        <p className={styles.text}>
          {Messages.aboutChildrenPrivacy()}
        </p>
        <div className={styles.labelText}>
          {Messages.changesToThisPrivacyPolicy()}
        </div>
        <p className={styles.text}>
          {Messages.aboutChangesPrivacyPolicy()}
        </p>
        <div className={styles.labelText}>
          {Messages.contactUs()}
        </div>
        <p className={styles.text}>
          {Messages.privacyPolicyQuestionsOrSuggestions()}
        </p>
        <div className={styles.titleText}>
          {Messages.termsAndConditions()}
        </div>
        <p className={styles.text}>
          {Messages.termsAndConditionsIntroduction()}
        </p>
        <p className={styles.text}>
          {Messages.teamRedLabsCommitment()}
        </p>
        <p className={styles.text}>
          {Messages.thePangolinApp()}
        </p>
        <p className={styles.text}>
          {Messages.awarenessOfTheAppFunctionality()}
        </p>
        <p className={styles.text}>
          {Messages.alongTheSameLine()}
        </p>
        <p className={styles.text}>
          {Messages.teamRedLabsResponsibility()}
        </p>
        <p className={styles.text}>
          {Messages.appAvailableOnAndroidAndIOSDevices()}
        </p>
        <div className={styles.labelText}>
          {Messages.changesTermsAndConditions()}
        </div>
        <p className={styles.text}>
          {Messages.termsAndConditionsUpdate()}
        </p>
        <div className={styles.labelText}>
          {Messages.contactUs()}
        </div>
        <p className={styles.text}>
          {Messages.termsAndConditionsQuestionsOrSuggestions()}
        </p>
        <div className={styles.row}>
          <DefaultButton onClick={onReject}>
            {Messages.decline()}
          </DefaultButton>
          <ActiveButton className={styles.button} onClick={onAccept}>
            {Messages.agree()}
          </ActiveButton>
        </div>
      </div>
    </div>
  );
};
